const getters = {
  userInfo: state => state.user.userInfo,
  token: state => state.user.token,
  isLogin: state => state.user.isLogin,
  host: state => state.user.host,
  isActive: state => state.user.isActive,
  carNum: state => state.car.carNum,
  myPath: state => state.user.myPath,
  catalogList: state => state.user.catalogList,
  userAuth: state => state.user.userAuth
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js